export const colorPlates = {
  blue: {
    first: {
      light: "#597FD4",
      lighter: "#AABEE9",
      lightGreyishBlue: "#1d1e206b",
      normal: "#294D9E",
      dark: "#224083",
      darker: "#14264D",
      heading1: {
        light: "#59A9D4",
        lighter: "#8FC5E2",
        normal: "#226183",
        dark: "#1B4D68",
        darker: "#14394D",
      },
      heading2: {
        light: "#59A9D4",
        lighter: "#8FC5E2",
        normal: "#226183",
        dark: "#1B4D68",
        darker: "#14394D",
      },
      heading3: {
        light: "#59A9D4",
        lighter: "#8FC5E2",
        normal: "#226183",
        dark: "#1B4D68",
        darker: "#14394D",
      },
      heading4: {
        light: "#59A9D4",
        lighter: "#8FC5E2",
        normal: "#226183",
        dark: "#1B4D68",
        darker: "#14394D",
      },
      heading5: {
        light: "#59A9D4",
        lighter: "#8FC5E2",
        normal: "#226183",
        dark: "#1B4D68",
        darker: "#14394D",
      },
      heading6: {
        light: "#59A9D4",
        lighter: "#8FC5E2",
        normal: "#226183",
        dark: "#1B4D68",
        darker: "#14394D",
      },
    },
    second: {
      light: "#BCCBE7",
      lighter: "#D5DFF0",
      normal: "#A3B8DE",
      dark: "#8AA5D5",
      darker: "#7191CC",
      heading1: {
        light: "#BCDAE7",
        lighter: "#D5E8F0",
        normal: "#A3CCDE",
        dark: "#8ABED5",
        darker: "#71B0CC",
      },
      heading2: {
        light: "#BCDAE7",
        lighter: "#D5E8F0",
        normal: "#A3CCDE",
        dark: "#8ABED5",
        darker: "#71B0CC",
      },
      heading3: {
        light: "#BCDAE7",
        lighter: "#D5E8F0",
        normal: "#A3CCDE",
        dark: "#8ABED5",
        darker: "#71B0CC",
      },
      heading4: {
        light: "#BCDAE7",
        lighter: "#D5E8F0",
        normal: "#A3CCDE",
        dark: "#8ABED5",
        darker: "#71B0CC",
      },
      heading5: {
        light: "#BCDAE7",
        lighter: "#D5E8F0",
        normal: "#A3CCDE",
        dark: "#8ABED5",
        darker: "#71B0CC",
      },
      heading6: {
        light: "#BCDAE7",
        lighter: "#D5E8F0",
        normal: "#A3CCDE",
        dark: "#8ABED5",
        darker: "#71B0CC",
      },
    },
    third: {
      light: "#455D81",
      lighter: "#516D97",
      normal: "#394D6B",
      dark: "#2D3D55",
      darker: "#212D3F",
      heading1: {
        light: "#457181",
        lighter: "#518597",
        normal: "#395E6B",
        dark: "#2D4B55",
        darker: "#21373F",
      },
      heading2: {
        light: "#457181",
        lighter: "#518597",
        normal: "#395E6B",
        dark: "#2D4B55",
        darker: "#21373F",
      },
      heading3: {
        light: "#457181",
        lighter: "#518597",
        normal: "#395E6B",
        dark: "#2D4B55",
        darker: "#21373F",
      },
      heading4: {
        light: "#457181",
        lighter: "#518597",
        normal: "#395E6B",
        dark: "#2D4B55",
        darker: "#21373F",
      },
      heading5: {
        light: "#457181",
        lighter: "#518597",
        normal: "#395E6B",
        dark: "#2D4B55",
        darker: "#21373F",
      },
      heading6: {
        light: "#457181",
        lighter: "#518597",
        normal: "#395E6B",
        dark: "#2D4B55",
        darker: "#21373F",
      },
    },
  },
  yellow: {
    first: {
      light: "#F9D528",
      lighter: "#FADB49",
      normal: "#F8CE07",
      dark: "#D7B306",
      darker: "#B69705",
      heading1: {
        light: "#D8F928",
        lighter: "#DEFA49",
        normal: "#D2F807",
        dark: "#B6D706",
        darker: "#9AB605",
      },
      heading2: {
        light: "#D8F928",
        lighter: "#DEFA49",
        normal: "#D2F807",
        dark: "#B6D706",
        darker: "#9AB605",
      },
      heading3: {
        light: "#D8F928",
        lighter: "#DEFA49",
        normal: "#D2F807",
        dark: "#B6D706",
        darker: "#9AB605",
      },
      heading4: {
        light: "#D8F928",
        lighter: "#DEFA49",
        normal: "#D2F807",
        dark: "#B6D706",
        darker: "#9AB605",
      },
      heading5: {
        light: "#D8F928",
        lighter: "#DEFA49",
        normal: "#D2F807",
        dark: "#B6D706",
        darker: "#9AB605",
      },
      heading6: {
        light: "#D8F928",
        lighter: "#DEFA49",
        normal: "#D2F807",
        dark: "#B6D706",
        darker: "#9AB605",
      },
    },
    second: {
      light: "#EFA200",
      lighter: "#FFB312",
      normal: "#CD8B00",
      dark: "#AB7400",
      darker: "#895D00",
      heading1: {
        light: "#EBEF00",
        lighter: "#FCFF12",
        normal: "#CACD00",
        dark: "#A8AB00",
        darker: "#878900",
      },
      heading2: {
        light: "#EBEF00",
        lighter: "#FCFF12",
        normal: "#CACD00",
        dark: "#A8AB00",
        darker: "#878900",
      },
      heading3: {
        light: "#EBEF00",
        lighter: "#FCFF12",
        normal: "#CACD00",
        dark: "#A8AB00",
        darker: "#878900",
      },
      heading4: {
        light: "#EBEF00",
        lighter: "#FCFF12",
        normal: "#CACD00",
        dark: "#A8AB00",
        darker: "#878900",
      },
      heading5: {
        light: "#EBEF00",
        lighter: "#FCFF12",
        normal: "#CACD00",
        dark: "#A8AB00",
        darker: "#878900",
      },
      heading6: {
        light: "#EBEF00",
        lighter: "#FCFF12",
        normal: "#CACD00",
        dark: "#A8AB00",
        darker: "#878900",
      },
    },
    third: {
      light: "#D0C0A6",
      lighter: "#DCD0BC",
      normal: "#C4B090",
      dark: "#B8A07A",
      darker: "#AC9064",
      heading1: {
        light: "#D0CEA6",
        lighter: "#DCDABC",
        normal: "#C4C290",
        dark: "#B8B67A",
        darker: "#ACAA64",
      },
      heading2: {
        light: "#D0CEA6",
        lighter: "#DCDABC",
        normal: "#C4C290",
        dark: "#B8B67A",
        darker: "#ACAA64",
      },
      heading3: {
        light: "#D0CEA6",
        lighter: "#DCDABC",
        normal: "#C4C290",
        dark: "#B8B67A",
        darker: "#ACAA64",
      },
      heading4: {
        light: "#D0CEA6",
        lighter: "#DCDABC",
        normal: "#C4C290",
        dark: "#B8B67A",
        darker: "#ACAA64",
      },
      heading5: {
        light: "#D0CEA6",
        lighter: "#DCDABC",
        normal: "#C4C290",
        dark: "#B8B67A",
        darker: "#ACAA64",
      },
      heading6: {
        light: "#D0CEA6",
        lighter: "#DCDABC",
        normal: "#C4C290",
        dark: "#B8B67A",
        darker: "#ACAA64",
      },
    },
  },
};


export const colorPateNames = [
  "blue", "yellow"
]
